import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TablerIconComponent } from "@ukam/ui-kit/icon/tabler-icon.component";
import { MaterialModule } from "@ukam/ui-kit/material.module";
import { TranslocoModule } from "@jsverse/transloco";
import { NAV_ITEMS } from '@ukam/shell/nav/nav-items.token';


@Component({
  selector: 'search-dialog',
  imports: [RouterModule, MaterialModule, TablerIconComponent, TranslocoModule, FormsModule],
  templateUrl: 'search-dialog.component.html'
})
export class AppSearchDialogComponent {
  searchText: string = '';
  navItems = inject(NAV_ITEMS);

  navItemsData = this.navItems.filter((navitem) => navitem.displayName);


}
